import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './authDispatcher';

const ProtectedRoute = ({ redirectPath = '/login' }) => {
  
  const location = useLocation();
  const { user } = useAuth();

  if (!user) {
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;